<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiExitToApp } from '@mdi/js'

export default {
  name: 'IconLogout',
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiExitToApp
    }
  }
}
</script>
